"use client"

import { useState, useEffect } from 'react'

export function RjHelpWidget() {
  const [showHelpWidget, setShowHelpWidget] = useState(false)
  const [isMinimized, setIsMinimized] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowHelpWidget(true)
    }, 5000) // 5 seconds

    return () => clearTimeout(timer)
  }, [])

  if (!showHelpWidget) return null

  return (
    <div className="fixed bottom-24 right-6 z-50 animate-in slide-in-from-bottom-4 fade-in duration-500">
      {!isMinimized ? (
        // Expanded Widget
        <div className="bg-white rounded-lg shadow-2xl border border-gray-200 p-4 max-w-xs relative">
          <button
            onClick={() => setIsMinimized(true)}
            className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 text-lg leading-none px-1"
            title="Minimize"
          >
            −
          </button>
          <div className="flex items-start gap-3">
            <div className="w-10 h-10 bg-[#c88546] rounded-full flex items-center justify-center flex-shrink-0">
              <span className="text-white font-bold text-sm">RJ</span>
            </div>
            <div className="flex-1">
              <p className="text-sm font-semibold text-gray-900 mb-1">Need help choosing?</p>
              <p className="text-xs text-gray-600 mb-3">R.J. can help you find the perfect floor plan</p>
              <div className="flex flex-col gap-2">
                <a
                  href="tel:9283610298"
                  className="bg-[#c88546] text-white px-3 py-2 rounded text-xs font-semibold hover:bg-[#b87436] transition-colors text-center"
                >
                  Call (928) 361-0298
                </a>
                <a
                  href="/get-started"
                  className="bg-white text-[#c88546] border border-[#c88546] px-3 py-2 rounded text-sm font-semibold hover:bg-[#c88546] hover:text-white transition-colors text-center"
                >
                  Get Free Consultation
                </a>
              </div>
            </div>
          </div>
        </div>
      ) : (
        // Minimized Widget - Just Small Buttons
        <div className="flex flex-col gap-2">
          <button
            onClick={() => setIsMinimized(false)}
            className="w-12 h-12 bg-[#c88546] rounded-full flex items-center justify-center shadow-lg hover:bg-[#b87436] transition-colors"
            title="Expand help widget"
          >
            <span className="text-white font-bold text-sm">RJ</span>
          </button>
          <a
            href="tel:9283610298"
            className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center shadow-lg hover:bg-green-600 transition-colors"
            title="Call R.J."
          >
            <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 20 20">
              <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
            </svg>
          </a>
          <a
            href="/get-started"
            className="w-12 h-12 bg-blue-500 rounded-full flex items-center justify-center shadow-lg hover:bg-blue-600 transition-colors"
            title="Get Free Consultation"
          >
            <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v14a2 2 0 002 2z" />
            </svg>
          </a>
        </div>
      )}
    </div>
  )
}